import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../../BaseController';
import { FragmentNames, ScoreMewsListAliases } from '../../../../codegen/index';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../../../constants/routes';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Inject } from '@odinjs/odin';
import { PanelAPI } from '@philips-internal/oswald-ui-components';
import InformationBarUtils from '../../../../controllers/commons/header/information-bar-header-utils';
import { ScoreAndIndexesService } from '../../scores-list/scores-list-service';
import { ScoresAndIndexesStatusType } from '../../score-types';

@Controller ({ component: ScoreMewsListAliases.LAYOUT_SCORE_MEWS_LIST, fragment: FragmentNames.SCORE_MEWS_LIST})
export default class ScoreMewsListController extends BaseController {

  @Inject(ScoreMewsListAliases.PANEL_GLOBAL_ACTIONS)
  private panelGlobalActions!: PanelAPI;

  @OnMount({ target: ScoreMewsListAliases.LAYOUT_SCORE_MEWS_LIST })
  handlePanelGlobalActionsMount(): void {
    const allowInfo = InformationBarUtils.allowInfo && ScoreAndIndexesService.isAllowEdit;
    this.panelGlobalActions.setVisible(allowInfo);
  }

  @OnClick({ target: ScoreMewsListAliases.ADD_SCORE_MEWS_CUSTOM_DYNAMIC_BUTTON })
  handleClickNew(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    applicationContext.redirect(
      ApplicationRoute.SCORE_MEWS_CREATE, {
        encounterId,
        patientId,
      }
    )
  }

  @OnClick({ target: ScoreMewsListAliases.DECK_SCORE_MEWS })
  handleClickCard(event: ClickEvent): void {
    const { idScoreIndexes, status } = event.value;
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    const allowInfo = InformationBarUtils.allowInfo && ScoreAndIndexesService.isAllowEdit;
    const accessViewer = ((status === ScoresAndIndexesStatusType.ACTIVE) || (!allowInfo));
    const route = accessViewer ? ApplicationRoute.SCORE_MEWS_VIEWER : ApplicationRoute.SCORE_MEWS_EDIT;

    applicationContext.redirect(route, {
      encounterId,
      idScoreIndexes,
      patientId,
    });
  }
}
